import { render, staticRenderFns } from "./ContextMenuBase.vue?vue&type=template&id=358f06f4&scoped=true&"
import script from "./ContextMenuBase.vue?vue&type=script&lang=js&"
export * from "./ContextMenuBase.vue?vue&type=script&lang=js&"
import style0 from "./ContextMenuBase.vue?vue&type=style&index=0&id=358f06f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f06f4",
  null
  
)

export default component.exports